import React from 'react';
import { connect } from 'react-redux';

import * as StoryActions from "../../data/stories/StoryActions";

import StorySettingsDialog from './StorySettingsDialog';

const mapStateToProps = (state, ownProps) => ({
    projects: Object.values(state.projects)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onSubmit: (formData) => {

        const renameStoryAction = StoryActions.renameStory(
            ownProps.story.id,
            formData.name
        );

        const changeStoryDescriptionAction = StoryActions.changeStoryDescription(
            ownProps.story.id,
            formData.description
        );

        const updateProjectsAction = StoryActions.updateProjects(
            ownProps.story.id,
            formData.projects
        );

        return Promise.all([
            dispatch(renameStoryAction),
            dispatch(changeStoryDescriptionAction),
            dispatch(updateProjectsAction)
        ]);
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StorySettingsDialog);
